import { AxiosError } from 'axios'

import { useTranslate } from './use-translate'
import { toast } from '@repo/ui/components'
import { useRouter } from '../i18n/navigation'

type TType = 'toast' | 'text' | 'both'

type TOptions = any & {
  type: TType
  noRedirect?: boolean
}

export const useErrorHandler = () => {
  const { t } = useTranslate()
  const { push } = useRouter()

  const errorHandler = (error: unknown, options: TOptions) => {
    if (error instanceof AxiosError && error?.response?.status === 401) {
      if (!options.noRedirect) {
        push('/auth/login')
      }
      return 'error_unauthorized'
    }

    const text = `error_${getErrorItems(error)}` as keyof typeof t
    const message = t(text)

    if (
      options.type === 'toast' ||
      options.type === 'both' ||
      options.type === undefined
    ) {
      toast.error({
        title: message,
      })
    }

    if (options.type === 'text' || options.type === 'both') {
      return message
    }
  }

  return { errorHandler }
}

const getErrorItems = (error: unknown) => {
  try {
    if (error instanceof AxiosError && error?.response) {
      try {
        const item = JSON.parse(error?.response?.data?.item)
        if (item?.item) {
          return item?.item ?? 'not_found'
        }
      } catch (_error) {
        console.log('🚀 ~ getErrorItems ~ _error:', _error)
        return error?.response?.data?.item ?? 'not_found'
      }
    }
    return 'not_found'
  } catch (error) {
    console.log('🚀 ~ getErrorItems ~ error:', error)
    return 'not_found'
  }
}
